import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ApiService from '../../services/ApiService';
import ListSearch from '../list/ListSearch';
import { LIST_ITEM_DELIMITER } from '../../util/form';

const sortData = (data, field) => {
  if (field) {
    return _.sortBy(data, field);
  }

  if (data.length && data[0].name) {
    return _.sortBy(data, 'name');
  }

  // not sure how to sort it
  return data;
};

const DbSearch = ({ modelName, limit, serverFilter, showAll, sortBy, setLoading, ...rest }) => {
  let data = [];

  const getData = (value, resultLimit) => {
    return new Promise(resolve => {
      ApiService.get(`search/db/${modelName}`, {
        params: {
          q: value,
          limit: resultLimit || limit,
          filter: serverFilter ? btoa(JSON.stringify(serverFilter)) : '',
        },
      })
        .then(res => {
          resolve(res);
        })
        .catch(() => {
          resolve({ data: [] });
        });
    });
  };

  const getSuggestionValue = suggestion => {
    const lowercaseModelName = modelName.toLowerCase();

    if (lowercaseModelName === 'user') {
      return `${suggestion.id}:${LIST_ITEM_DELIMITER}${suggestion.firstName} ${suggestion.lastName}`;
    }

    if (lowercaseModelName === 'loyaltycustomer') {
      const email = suggestion.email ? `<${suggestion.email}>` : '';
      return `${suggestion.id}:${LIST_ITEM_DELIMITER}${suggestion.firstName || ''} ${
        suggestion.lastName || ''
      } ${email}`;
    }

    if (lowercaseModelName === 'quote') {
      return `${suggestion.id}: Quote`;
    }

    return `${suggestion.id}:${LIST_ITEM_DELIMITER}${suggestion.name}`;
  };

  const loadSuggestions = (value, limit) => {
    if (showAll) {
      if (data.length) {
        return Promise.resolve(data);
      }

      setLoading(true);
      return getData('?', 1000).then(res => {
        data = sortData(res.data || [], sortBy);
        setLoading(false);
        return data;
      });
    }

    return new Promise(resolve => {
      getData(value, limit).then(res => {
        if (sortBy || value === '?') {
          resolve(sortData(res.data, sortBy));
        } else {
          resolve(res.data);
        }
      });
    });
  };

  const renderSuggestion = suggestion => {
    if (suggestion.selectAll) {
      return <div style={{ fontWeight: 'bold' }}>Select All</div>;
    }

    switch (modelName.toLowerCase()) {
      case 'user':
        return (
          <div>
            {suggestion.firstName} {suggestion.lastName}
          </div>
        );

      case 'branch':
        return (
          <div>
            <div>{suggestion.name}</div>
            <div style={{ fontSize: '80%', fontWeight: 'bold' }}>{suggestion.company.name}</div>
          </div>
        );

      case 'loyaltycustomer':
        return (
          <div>
            <div>
              {suggestion.firstName} {suggestion.lastName}
            </div>
            <div>
              {!!suggestion.phone && (
                <>
                  <i className="zmdi zmdi-phone" /> {suggestion.phoneNumber}
                </>
              )}
              {suggestion.email}
            </div>
          </div>
        );

      case 'quote':
        return (
          <div>
            <div>{suggestion.id}</div>
          </div>
        );

      default:
        return <div>{suggestion.name || suggestion.id}</div>;
    }
  };


  return (
    <ListSearch
      {...rest}
      limit={limit}
      debounce={200}
      getSuggestionValue={getSuggestionValue}
      loadSuggestions={loadSuggestions}
      renderSuggestion={renderSuggestion}
    />
  );
};

DbSearch.defaultProps = {
  allowSelectAll: false,
  filter: null,
  filterSuggestions: suggestions => suggestions,
  highlightFirstSuggestion: true,
  limit: 25,
  onBlur: () => {},
  onChange: () => {},
  setLoading: () => {},
  shouldRenderSuggestions: () => true,
  showAll: false,
  sortBy: '',
  value: '',
};

DbSearch.propTypes = {
  allowSelectAll: PropTypes.bool,
  controlId: PropTypes.string,
  serverFilter: PropTypes.object,
  filter: PropTypes.object,
  filterSuggestions: PropTypes.func,
  highlightFirstSuggestion: PropTypes.bool,
  limit: PropTypes.number,
  modelName: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onSuggestionSelected: PropTypes.func,
  setLoading: PropTypes.func,
  shouldRenderSuggestions: PropTypes.func,
  showAll: PropTypes.bool,
  sortBy: PropTypes.string,
  value: PropTypes.string,
};

export default DbSearch;
